import { Injectable, inject, signal } from '@angular/core';
import { Stats } from '../models/stats';
import { FormService } from '../../shared/services/form.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  protected resources = inject(FormService).resources;

  constructor() { }

  getContractLength(length: number): Stats {
    return {
      content: {
        title: 'Contratos',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.contract.toLowerCase() as string,
        },
      },
    }
  }
  getImageLength(length: number): Stats {
    return {
      content: {
        title: 'Imágenes',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.image.toLowerCase() as string,
        },
      },

    }
  }
  getPermissionLength(length: number): Stats {
    return {
      content: {
        title: 'Permisos',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.permissions.toLowerCase() as string,
        },
      },
    }
  }
  getAdvertisingLength(length: number): Stats {
    return {
      content: {
        title: 'Pantallas',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.advertising.toLowerCase() as string,
        },
      },
    }
  }

  getBranchLength(length: number): Stats {
    return {
      content: {
        title: 'Sucursales',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.branch.toLowerCase() as string,
        },
      },
    }
  }

  getUserLength(length: number): Stats {
    return {
      content: {
        title: 'Usuarios',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.user.toLowerCase() as string,
        },
      },
    }
  }
  getServicioLength(length: number): Stats {
    return {
      content: {
        title: 'Servicios',
        value: length.toString(),
        button: {
          icon: 'pi pi-info-circle',
          resource: this.resources.servicio.toLowerCase() as string,
        },
      },
    }
  }
}
